import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { v4 as uuid } from "uuid";
    

export class InvoiceTimeRegistration extends Model {
      key: string = "";
      selected:boolean = true;
      price: number = 0;
      worktype_key: string;

      constructor(data = null) {
            super(data);

            
            if(data) {
            Object.keys(data).map((item) => {
                if(this[item] != undefined) {
                    this[item] = data[item];
                }
            });
            if(data["work_key"]) {
                this.worktype_key = data["work_key"]; 
            }
            
            }
        }      
      
    }